export default __webpack_public_path__ + "static/media/pettey.1f2aba84.png";